









import Person from '@/types/Person.interface'
import Vue, { PropType } from 'vue'
import HiddenInput from '@/types/HiddenInput.interface'
import HiddenInputVue from './HiddenInput.vue'
export default Vue.extend({
    components: { 'hidden-input': HiddenInputVue },
    props: {
        readonly: {
            type: Boolean,
            default: false
        },
        person: {
            type: Object as PropType<Person>,
            required: true
        }
    },
    computed: {
        moreInfoItems(): HiddenInput[] {
            return [
                {
                    name: 'Company',
                    label: 'Company',
                    validate: 'max:100',
                    value: this.person.company,
                    callback: (val: string) => (this.person.company = val)
                },
                {
                    name: 'Website',
                    label: 'Website',
                    validate: 'url',
                    value: this.person.website,
                    callback: (val: string) => (this.person.website = val)
                },
                {
                    name: 'Email',
                    label: 'Email',
                    validate: 'max:191|email',
                    value: this.person.email_default.address,
                    callback: (val: string) => (this.person.email_default.address = val)
                }
            ]
        }
    }
})
